import { render } from "./Bar_Chart.vue?vue&type=template&id=2678bc60&scoped=true"
import script from "./Bar_Chart.vue?vue&type=script&lang=js"
export * from "./Bar_Chart.vue?vue&type=script&lang=js"

import "./Bar_Chart.vue?vue&type=style&index=0&id=2678bc60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2678bc60"]])

export default __exports__